export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  maxHeight: '420px',
  overflowY: 'auto',
};

export const entryStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  paddingBottom: '12px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  '&:last-of-type': {
    paddingBottom: 0,
    borderBottom: 'none',
  },
};

export const metaRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
